import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

export default function DMSRoute() {
  const { tenantModule } = useAuth();
  if (tenantModule !== "dms") {
    return <Navigate to="/manufacturing/dashboard" replace />;
  }
  return <Outlet />;
}
